import { generateTableSlice } from "./sliceTable";

const sliceCaregiverTable = generateTableSlice("caregiver");

export const ActionsCaregiverTable = sliceCaregiverTable.actions;
export const ReducerCaregiverTable = sliceCaregiverTable.reducer;
